import { AuthActions } from './actions';
import { AuthMutations } from './mutations';

const states = () => ({
    userInfo: {
        email: '',
        userId: 0,
        userName: '',
    },
    customerInfo: {},
});

export default {
    actions: AuthActions,
    mutations: AuthMutations,
    namespaced: true,
    state: states,
};
